import remarkGfm from 'remark-gfm'
import remarkMath from 'remark-math'
import remarkParse from 'remark-parse'
import remarkRehype from 'remark-rehype'
import rehypeStringify from 'rehype-stringify'
import rehypeMathJax from 'rehype-mathjax'
import { unified } from 'unified'
import { isEmpty } from 'lodash'

const markdownProcessor = unified()
    .use(remarkParse)
    .use(remarkGfm)
    .use(remarkMath)
    .use(remarkRehype)
    .use(rehypeMathJax)
    .use(rehypeStringify)

export const convertMarkdownToHTML = (markdown: string) => {
    return markdownProcessor.processSync(markdown).toString()
}

export const isValidMarkdown = (markdown: string) => {
    if (isEmpty(markdown)) {
        return false
    }

    const markdownPatterns = [
        /\*\*(.*?)\*\*/, // **bold**
        /_(.*?)_/, // _italic_
        /`([^`]+)`/, // `code`
        /^#{1,6}\s.+/m, // # heading
        /\[[^\]]+\]\([^)]+\)/, // [text](url)
        /^>.+/m, // blockquote
        /!\[[^\]]*\]\([^)]+\)/, // image
        /(\*|-|\+)\s.+/, // unordered list
        /^\d+\.\s.+/m, // ordered list
        /\|.*\|/, // table
    ]
    return markdownPatterns.some(pattern => pattern.test(markdown))
}
